module.exports = __webpack_public_path__ + "static/img/40001 (4).fd78de8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40001 (4).webp
// module id = lVSB
// module chunks = 14